import Backbone from 'backbone';

export default class PopupView extends Backbone.View {
    findElement() {
        var el = document.getElementById("spree-popup-container");
        if (!el) {
            el = $('<div id="spree-popup-container"></div>');
            $(el).prependTo($("body"));
        }
        this.setElement(el);
    }

    removeElement() {
        this.$el.remove();
    }

    events() {
        return {
            "click .close": "close",
        }
    }

    initialize(options) {
        this.data = options['data'];
        this.template = options['template'];

        this.findElement();
        this.render();

        this.listenTo(this.model, "change", this.render);
    }

    close(event) {
        event.preventDefault();

        this.stopListening();
        this.undelegateEvents();
        this.removeElement();
    }

    render() {
        this.$el.html(this.template());
    }
}



// WEBPACK FOOTER //
// ./frontend/js/views/popup.js